import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useSessionTimeout } from '../sessionTimeout';
import PropTypes from 'prop-types';
 
export const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);
  const { user } = useSelector((state) => state.auth);
  
  useSessionTimeout();
 
  const checkAuth = () => {
   const loggedIn = sessionStorage.getItem("isLogged");
   if (!loggedIn) {
      navigate("/login", { replace: true });
      return;
    }

    if (user?.role?.toLowerCase() === "vkyc auditor") {
      if (location.pathname !== "/product-catalogue") {
        navigate("/unauthorized", { replace: true });
        return;
      }
    }
    setAuthChecked(true);
  };
 
  useEffect(() => {
    checkAuth();
 
    const handlePopState = () => {
      checkAuth();
    };
 
    window.addEventListener("popstate", handlePopState);
 
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);
 
  useEffect(() => {
    checkAuth();
  }, [location]);
 
  if (!authChecked) return null;
 
  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};